import {List} from 'immutable'
import _ from 'lodash'

const getOptions = (state) => state.getIn(['exchange', 'options'], List());

const isAnyVisible = (options)=>{
    if(!options) return false
    let any_visible = false
    _.forEach(options, (o)=>{
        if(o.visible)
            any_visible = true
    })
    return any_visible
}
const isAnyActive = (options) => {
    return _
        .chain(options)
        .flatMap(o =>([o, ...o.children]))
        .some(o=>{return o.visible && o.notification})
        .value()
}

const getVisibleOption = (options)=>{
    return _
        .chain(options)
        .flatMap(o =>([o, ...o.children]))
        .filter(o=>{return o.visible })
        .value()
}

const getActiveOptions = (options)=>{
    return _
        .chain(options)
        .flatMap(o =>([o, ...o.children]))
        .filter(o=>{return o.visible && o.notification})
        .value()
}

export default {
    getOptions, isAnyVisible,isAnyActive, getActiveOptions, getVisibleOption
}



// WEBPACK FOOTER //
// ./src/model/Exchange/selector.js